/** Persian labels + presentation helpers for the Operations module. */

export const OPERATION_TYPE_LABELS = {
    WRP_CERTIFICATE_ISSUE: 'صدور گواهی (WRP)',
    WRP_CERTIFICATE_REVOKE: 'ابطال گواهی (WRP)',
    SABTE_AHVAL_IDENTITY_INQUIRY: 'استعلام هویت (ثبت احوال)',
    SHAHKAR_OWNERSHIP_MATCH: 'تطابق مالکیت سیم‌کارت (شاهکار)',
    PAYMENT_VERIFY: 'تایید پرداخت',
    PAYMENT_RECONCILE: 'تسویه پرداخت',
    SMS_SEND: 'ارسال پیامک',
    EKYC_CALLBACK_RECONCILE: 'تسویه بازگشتی احراز هویت',
    DASTINE_STATUS_POLL: 'بررسی وضعیت دستینه',
};

export const PROVIDER_LABELS = {
    wrp: 'مرجع صدور گواهی (WRP)',
    sabte_ahval: 'ثبت احوال',
    shahkar: 'شاهکار',
    payment_gateway: 'درگاه پرداخت',
    sms: 'پیامک',
    ekyc: 'احراز هویت',
    dastine: 'دستینه',
};

export const OPERATION_STATUS_LABELS = {
    QUEUED: 'در صف',
    IN_PROGRESS: 'در حال اجرا',
    RETRYING: 'در حال تلاش مجدد',
    SUCCEEDED: 'موفق',
    FAILED: 'ناموفق',
    DEAD_LETTERED: 'صف مرگ',
    CANCELLED: 'لغو شده',
};

export const OPERATION_STATUS_VARIANTS = {
    QUEUED: 'info',
    IN_PROGRESS: 'info',
    RETRYING: 'warning',
    SUCCEEDED: 'success',
    FAILED: 'alert',
    DEAD_LETTERED: 'alert',
    CANCELLED: 'neutral',
};

export const DLQ_STATUS_LABELS = {
    PENDING_REVIEW: 'در انتظار بررسی',
    UNDER_REVIEW: 'در حال بررسی',
    RESOLVED: 'حل‌شده',
    COMPENSATED: 'جبران‌شده',
    IGNORED: 'نادیده گرفته شده',
};

export const DLQ_STATUS_VARIANTS = {
    PENDING_REVIEW: 'warning',
    UNDER_REVIEW: 'info',
    RESOLVED: 'success',
    COMPENSATED: 'success',
    IGNORED: 'neutral',
};

export const COMPENSATION_JOB_TYPE_LABELS = {
    PAYMENT_VERIFIED_WRP_FAILED: 'بازپرداخت پس از شکست صدور',
    REVOKE_REQUESTED_WRP_UNAVAILABLE: 'تلاش مجدد برای ابطال گواهی',
};

export const COMPENSATION_STATUS_LABELS = {
    PENDING: 'در انتظار',
    IN_PROGRESS: 'در حال اجرا',
    COMPLETED: 'تکمیل شده',
    FAILED: 'ناموفق',
    CANCELLED: 'لغو شده',
};

export const COMPENSATION_STATUS_VARIANTS = {
    PENDING: 'info',
    IN_PROGRESS: 'warning',
    COMPLETED: 'success',
    FAILED: 'alert',
    CANCELLED: 'neutral',
};

export const CIRCUIT_STATE_LABELS = {
    CLOSED: 'سالم',
    OPEN: 'قطع',
    HALF_OPEN: 'نیمه‌فعال',
};

export const CIRCUIT_STATE_VARIANTS = {
    CLOSED: 'success',
    OPEN: 'alert',
    HALF_OPEN: 'warning',
};

export const formatDateTime = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return new Intl.DateTimeFormat('fa-IR', {
        dateStyle: 'short',
        timeStyle: 'short',
    }).format(date);
};